import { graphql } from 'gatsby';
import * as React from 'react';
import LandingPage from '../base-landing-page/landing-page';
import { Categories } from '../../data/blog-landing-filter-menu';
import { LandingPageProperties, LandingPageState } from '../../interfaces/landing-page';

class BlogLandingPage extends React.Component<LandingPageProperties, LandingPageState> {
  render() {
    return <LandingPage 
        {...this.props} 
        title={'page.bloglanding.title'} 
        description={'page.bloglanding.description'} 
        filterCategories={Categories} 
        bannerImage={null}>
      </LandingPage>;
  }
}

export default BlogLandingPage;

export const pageQuery = graphql`
  query blogLandingQuery($locale: String!) {
    allContentfulBlogPost(
      filter: {slug: {ne: null}, fields: {locale: {eq: $locale}}, time: {ne: null}, isLabsPost: {ne: true}}
      sort: {time: DESC}
    ) {
      edges {
        node {
          id
          title
          fields {
            locale
          }
          activeTranslations
          labels
          time
          slug
          excerpt
          heroImage: image {
            title
            file {
              url
            }
          }
        }
      }
    }
    site {
      siteMetadata {
        title
        siteUrl
      }
    }
  }
`;
